import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/info.png'
import _imports_1 from '@/assets/icon/i-01.png'
import _imports_2 from '@/assets/icon/userinfo.png'
import _imports_3 from '@/assets/icon/zhinanzhen.png'
import _imports_4 from '@/assets/icon/phone.png'


const _withScopeId = n => (_pushScopeId("data-v-3049ccc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contents" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contents-left" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "web-title" }, "欢迎来到设纪元"),
    /*#__PURE__*/_createElementVNode("span", { class: "web-login" }, "请登录"),
    /*#__PURE__*/_createElementVNode("span", { class: "web-register" }, "免费注册")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents-right" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "usermsg" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
      /*#__PURE__*/_createTextVNode(" 我的消息 "),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "userinfo" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createTextVNode(" 个人中心 "),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
      /*#__PURE__*/_createElementVNode("div", { class: "nav-info" }, [
        /*#__PURE__*/_createElementVNode("span", null, " 注册流程 "),
        /*#__PURE__*/_createElementVNode("span", null, " 作品上传 "),
        /*#__PURE__*/_createElementVNode("span", null, " 购物流程 "),
        /*#__PURE__*/_createElementVNode("span", null, " 作品发布 "),
        /*#__PURE__*/_createElementVNode("span", null, " 方案下载 "),
        /*#__PURE__*/_createElementVNode("span", null, " 作品发布 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "guide" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
      /*#__PURE__*/_createTextVNode(" 新手指南 "),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "mobile" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
      /*#__PURE__*/_createTextVNode(" 移动端访问 "),
      /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lay_header = _resolveComponent("lay-header")!
  const _component_header_nav_mid = _resolveComponent("header-nav-mid")!
  const _component_lay_body = _resolveComponent("lay-body")!

  return (_openBlock(), _createBlock(_component_lay_body, null, {
    default: _withCtx(() => [
      _createVNode(_component_lay_header, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_header_nav_mid)
    ]),
    _: 1
  }))
}